function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 96.3,
  r: 80,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 96.3,
  r: 80,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M96 77.3c36.6 0 65.9-8.2 70.4-19.1l-1.4-2.5c-.9 10.6-32.1 19.5-69 19.5s-68.1-8.8-69-19.5l-1.4 2.5C30.1 69.1 59.4 77.3 96 77.3zM96 35.3c-23.4 0-36-5.9-36-11.5a1 1 0 112 0c0 4.5 14 9.5 34 9.5s34-5 34-9.5a1 1 0 112 0c0 5.6-12.6 11.5-36 11.5zM35.7 148.9l3.5 3.8c12.9 5.3 33.3 8.6 56.8 8.6s43.9-3.4 56.8-8.6l3.5-3.8c-11.9 6.2-34.7 10.4-60.3 10.4s-48.4-4.3-60.3-10.4z",
  fill: "#f3f3f3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M87.6 16.7l-3.4.4C60 40.1 46.8 67.7 46.8 95.5s14.3 56.8 39.5 80.2l3.3.3c-26-23.3-40.8-52.5-40.8-80.5s13.7-55.8 38.8-78.8zM146.6 95.5c0 27.9-14.7 56.9-40.4 80.1l3.5-.5c24.8-23.2 38.9-52 38.9-79.6s-13-54.8-36.7-77.6l-3.6-.6c24.7 22.8 38.3 50.4 38.3 78.2zM96.7 176.3h2V16.4h-2z",
  fill: "#f3f3f3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9 108.4c14 10.3 47 16.2 79.1 16.2s65.1-5.9 79.1-16.2c.3-2.1.5-4.1.7-6.2-3.4 4-10.7 7.8-21 10.9-15.7 4.7-36.6 7.3-58.8 7.3s-43.1-2.6-58.8-7.3c-10.3-3.1-17.6-7-21-10.9.2 2.1.4 4.2.7 6.2z",
  fill: "#e60000"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0V0z"
});

var SvgInternationalHiDark = function SvgInternationalHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "79a83c09-a361-44f7-a585-f6607e827d94"
  }, _ref, /*#__PURE__*/React.createElement("path", {
    d: "M16 95.3v1a80 80 0 10160 0v-1a80 80 0 01-160 0z",
    style: {
      isolation: "isolate"
    },
    fill: "#f0f0f0"
  }), _ref2, _ref3, _ref4, _ref5, _ref6));
};

export default SvgInternationalHiDark;